import { render, staticRenderFns } from "./source.vue?vue&type=template&id=20470a40&scoped=true"
import script from "./source.vue?vue&type=script&lang=js"
export * from "./source.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20470a40",
  null
  
)

export default component.exports